import React from "react";
import { Container, Grid, Typography, Card, CardContent, Avatar, Box, IconButton } from "@mui/material";
import LinkedInIcon from "@mui/icons-material/LinkedIn"; // Import LinkedIn icon
import { Footer, Header } from "./basicComponent/Basic";
const teamMembers = [
  {
    name: "Mohd Arif",
    position: "Lead Developer",
    imageUrl: "https://media.licdn.com/dms/image/v2/C4D03AQG4lFYtkftrCg/profile-displayphoto-shrink_100_100/profile-displayphoto-shrink_100_100/0/1656696335235?e=1734566400&v=beta&t=h40QPr5Q98ghGYNvbdSfifXh86QjUDaNjcMaLibV7hc",
    description: "Mohd Arif leads the development team at ManageEdu, focusing on delivering high-quality code and ensuring a seamless user experience.",
    social: "https://www.linkedin.com/in/mohd-arif-115b87231",
    vision: "Our vision at ManageEdu is to revolutionize the way educational institutions manage student data, fees, and courses, making it easier, faster, and more efficient for both students and administrators.",
  },
//   {
//     name: "Jane Smith",
//     position: "CTO",
//     imageUrl: "https://via.placeholder.com/150",
//     description: "Jane oversees all technical aspects of ManageEdu, ensuring the platform is robust and scalable.",
//   },
//   {
//     name: "Sam Wilson",
//     position: "Lead Developer",
//     imageUrl: "https://via.placeholder.com/150",
//     description: "Sam leads the development team, focusing on delivering high-quality code and ensuring a seamless user experience.",
//   },
];

const Team = () => {
  return (
    <>
     <Header/>
    <Container sx={{ marginTop: "50px", marginBottom: "50px" }}>
      <Box sx={{ textAlign: 'center', marginBottom: "40px" }}>
        <Typography variant="h4" align="center" sx={{ fontWeight: 'bold', color: '#00274d', marginBottom: "20px" }}>
          Meet Our Team
        </Typography>
        <Typography variant="body1" align="center" sx={{ maxWidth: "600px", margin: "auto", color: "#666" }}>
          The dedicated professionals behind ManageEdu, who are committed to making education management easy.
        </Typography>
      </Box>

      <Grid container spacing={4} justifyContent="center">
        {teamMembers.map((member, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card sx={{
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
              borderRadius: "12px",
              transition: "transform 0.3s ease-in-out",
              "&:hover": {
                transform: "translateY(-10px)",
                boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.15)",
              }
            }}>
              <CardContent sx={{ textAlign: "center", padding: "30px" }}>
                <Avatar
                  alt={member.name}
                  src={member.imageUrl}
                  sx={{
                    width: 120,
                    height: 120,
                    margin: "0 auto 20px",
                    border: "5px solid #00274d",
                    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)"
                  }}
                />
                <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#00274d' }}>
                  {member.name}
                </Typography>
                <Typography variant="subtitle1" color="textSecondary" sx={{ fontSize: "16px", marginBottom: "20px", color: '#00274d' }}>
                  {member.position}
                </Typography>
                <Typography variant="body2" sx={{ color: "#555", marginBottom: "20px" }}>
                  {member.description}
                </Typography>
                {/* Social Media Icon */}
                {member.social && (
                  <Box>
                    <IconButton
                      component="a"
                      href={member.social}
                      target="_blank"
                      sx={{
                        color: "#0077b5", // LinkedIn blue
                        "&:hover": {
                          color: "#005582", // Darker LinkedIn blue on hover
                        }
                      }}
                    >
                      <LinkedInIcon sx={{ fontSize: 40 }} />
                    </IconButton>
                  </Box>
                )}
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
    <Footer/>
    </>
  );
};

export default Team;
